import React from 'react'
import { Testimonial } from '../data/testimonials'

const STAR_PATH = 'M12 2.5l2.9 6.2 6.7.8-5 4.6 1.4 6.7L12 17.4 6 20.8l1.4-6.7-5-4.6 6.7-.8z'

interface TestimonialCardProps {
  testimonial: Testimonial
  style?: React.CSSProperties
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial, style }) => (
  <figure className="v2-testimonial" style={style}>
    <figcaption>
      <span className="v2-testimonial__stars">
        {Array.from({ length: 5 }).map((_, i) => (
          <svg key={i} aria-hidden="true" viewBox="0 0 24 24" width={19} height={19} fill="#D9A441">
            <path d={STAR_PATH} />
          </svg>
        ))}
      </span>
      {testimonial.name}
    </figcaption>
    <blockquote>“{testimonial.quote}”</blockquote>
  </figure>
)

export default TestimonialCard
